import React from 'react'
import { FiChevronRight } from 'react-icons/fi'

import Link from '~components/Link'

import style from './More.module.scss'

const More = ({
  to,
  right,
  children
}) => (
  <div 
    className={style.more}
    data-align-right={ right === ''}
  >
    <Link to={to}>
      { children }
      <FiChevronRight />
    </Link>
  </div>
)

export default More